import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'installment-integration-tables',
  storeModule.createStoreModule('installment-integration-tables')
)
